<template>
  <div class="contact infoPage">
    <div class="infoHeader">
      <font-awesome-icon icon="exclamation-triangle" class="w3-right headerIcon" /><h2>{{$t('beta.chessAdministratorBeta')}}</h2>
    </div>
    <div class="infoText">   
      <p>{{$t('beta.paragraph1')}}</p>
      <p>{{$t('beta.paragraph2')}}</p>
      <p>{{$t('beta.paragraph3')}}
        <br/>
        {{$t('beta.paragraph4')}}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Beta',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
